import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.Estado;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        ClaveSat: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class EstadoFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelector(this.value, x => validar(x));
    hasError = createSelector(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);

        return (
            <div>
                <kea.Title titulo="Zona extendida" onRegresar={() => history.go("../")} />
                {kea.autogrid(3, [
                    <Text field="Nombre" label="Nombre" />,
                    <Text field="ClaveSat" label="ClaveSat" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const EstadoForm = componentToRx(EstadoFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/DireccionEstado/edit/form.tsx